export const CRYPTO_ICONS: Record<string, string> = {
  BTC: 'https://assets.coingecko.com/coins/images/1/small/bitcoin.png',
  ETH: 'https://assets.coingecko.com/coins/images/279/small/ethereum.png',
  BNB: 'https://assets.coingecko.com/coins/images/825/small/bnb-icon2_2x.png',
  SOL: 'https://assets.coingecko.com/coins/images/4128/small/solana.png',
  USDC: 'https://assets.coingecko.com/coins/images/6319/small/usdc.png',
  XRP: 'https://assets.coingecko.com/coins/images/44/small/xrp-symbol-white-128.png',
  DOGE: 'https://assets.coingecko.com/coins/images/5/small/dogecoin.png',
  TON: 'https://assets.coingecko.com/coins/images/17980/small/ton_symbol.png',
  ADA: 'https://assets.coingecko.com/coins/images/975/small/cardano.png',
  SHIB: 'https://assets.coingecko.com/coins/images/11939/small/shiba.png',
  AVAX: 'https://assets.coingecko.com/coins/images/12559/small/Avalanche_Circle_RedWhite_Trans.png',
  TRX: 'https://assets.coingecko.com/coins/images/1094/small/tron-logo.png',
  LINK: 'https://assets.coingecko.com/coins/images/877/small/chainlink-new-logo.png',
  DOT: 'https://assets.coingecko.com/coins/images/12171/small/polkadot.png',
  BCH: 'https://assets.coingecko.com/coins/images/780/small/bitcoin-cash-circle.png',
  NEAR: 'https://assets.coingecko.com/coins/images/10365/small/near.jpg',
  MATIC: 'https://assets.coingecko.com/coins/images/4713/small/polygon.png',
  UNI: 'https://assets.coingecko.com/coins/images/12504/small/uni.jpg',
  LTC: 'https://assets.coingecko.com/coins/images/2/small/litecoin.png',
  ETC: 'https://assets.coingecko.com/coins/images/453/small/ethereum-classic-logo.png',
  APT: 'https://assets.coingecko.com/coins/images/26455/small/aptos_round.png',
  HBAR: 'https://assets.coingecko.com/coins/images/3688/small/hbar.png',
  FIL: 'https://assets.coingecko.com/coins/images/12817/small/filecoin.png',
  ATOM: 'https://assets.coingecko.com/coins/images/1481/small/cosmos_hub.png',
  XLM: 'https://assets.coingecko.com/coins/images/100/small/Stellar_symbol_black_RGB.png',
  VET: 'https://assets.coingecko.com/coins/images/1167/small/VET_Token_Icon.png',
  MKR: 'https://assets.coingecko.com/coins/images/1364/small/Mark_Maker.png',
  INJ: 'https://assets.coingecko.com/coins/images/12882/small/Secondary_Symbol.png',
  SUI: 'https://assets.coingecko.com/coins/images/26375/small/sui_asset.jpeg',
  AAVE: 'https://assets.coingecko.com/coins/images/12645/small/AAVE.png',
  GRT: 'https://assets.coingecko.com/coins/images/13397/small/Graph_Token.png',
  OP: 'https://assets.coingecko.com/coins/images/25244/small/Optimism.png',
  ARB: 'https://assets.coingecko.com/coins/images/16547/small/photo_2023-03-29_21.47.00.jpeg',
  THETA: 'https://assets.coingecko.com/coins/images/2538/small/theta-token-logo.png',
  ALGO: 'https://assets.coingecko.com/coins/images/4380/small/download.png',
  FLOW: 'https://assets.coingecko.com/coins/images/13446/small/5f6294c0c7a8cda55cb1c936_Flow_Wordmark.png',
  SAND: 'https://assets.coingecko.com/coins/images/12129/small/sandbox_logo.jpg',
  MANA: 'https://assets.coingecko.com/coins/images/878/small/decentraland-mana.png',
  QNT: 'https://assets.coingecko.com/coins/images/3370/small/5ZOu7brX_400x400.jpg',
  AXS: 'https://assets.coingecko.com/coins/images/13029/small/axie_infinity_logo.png',
  CHZ: 'https://assets.coingecko.com/coins/images/8834/small/CHZ_Token_updated.png',
  GALA: 'https://assets.coingecko.com/coins/images/12493/small/GALA-COINGECKO.png',
  ENJ: 'https://assets.coingecko.com/coins/images/1102/small/enjin-coin-logo.png',
  XTZ: 'https://assets.coingecko.com/coins/images/976/small/Tezos-logo.png',
  NEO: 'https://assets.coingecko.com/coins/images/480/small/NEO_512_512.png',
  IOTA: 'https://assets.coingecko.com/coins/images/692/small/IOTA_Swirl.png',
};

export const CURRENCY_FLAGS: Record<string, string> = {
  USD: 'https://flagcdn.com/w40/us.png',
  EUR: 'https://flagcdn.com/w40/eu.png',
  GBP: 'https://flagcdn.com/w40/gb.png',
  JPY: 'https://flagcdn.com/w40/jp.png',
  AUD: 'https://flagcdn.com/w40/au.png',
  CAD: 'https://flagcdn.com/w40/ca.png',
  CHF: 'https://flagcdn.com/w40/ch.png',
  NZD: 'https://flagcdn.com/w40/nz.png',
  CNH: 'https://flagcdn.com/w40/cn.png',
  HKD: 'https://flagcdn.com/w40/hk.png',
  SGD: 'https://flagcdn.com/w40/sg.png',
  SEK: 'https://flagcdn.com/w40/se.png',
  NOK: 'https://flagcdn.com/w40/no.png',
  DKK: 'https://flagcdn.com/w40/dk.png',
  PLN: 'https://flagcdn.com/w40/pl.png',
  HUF: 'https://flagcdn.com/w40/hu.png',
  CZK: 'https://flagcdn.com/w40/cz.png',
  TRY: 'https://flagcdn.com/w40/tr.png',
  ZAR: 'https://flagcdn.com/w40/za.png',
  MXN: 'https://flagcdn.com/w40/mx.png',
  BRL: 'https://flagcdn.com/w40/br.png',
  INR: 'https://flagcdn.com/w40/in.png',
  KRW: 'https://flagcdn.com/w40/kr.png',
  TWD: 'https://flagcdn.com/w40/tw.png',
  THB: 'https://flagcdn.com/w40/th.png',
  IDR: 'https://flagcdn.com/w40/id.png',
  MYR: 'https://flagcdn.com/w40/my.png',
  PHP: 'https://flagcdn.com/w40/ph.png',
  SAR: 'https://flagcdn.com/w40/sa.png',
  AED: 'https://flagcdn.com/w40/ae.png',
  QAR: 'https://flagcdn.com/w40/qa.png',
  ILS: 'https://flagcdn.com/w40/il.png',
  CLP: 'https://flagcdn.com/w40/cl.png',
  COP: 'https://flagcdn.com/w40/co.png',
  PEN: 'https://flagcdn.com/w40/pe.png',
};

export const STOCK_LOGOS: Record<string, { logo: string; bg: string; text: string }> = {
  AAPL: { logo: 'https://logos-api.apistemic.com/domain:apple.com', bg: '#000000', text: '#FFFFFF' },
  MSFT: { logo: 'https://logos-api.apistemic.com/domain:microsoft.com', bg: '#00A4EF', text: '#FFFFFF' },
  GOOGL: { logo: 'https://logos-api.apistemic.com/domain:google.com', bg: '#4285F4', text: '#FFFFFF' },
  AMZN: { logo: 'https://logos-api.apistemic.com/domain:amazon.com', bg: '#FF9900', text: '#000000' },
  TSLA: { logo: 'https://logos-api.apistemic.com/domain:tesla.com', bg: '#CC0000', text: '#FFFFFF' },
  META: { logo: 'https://logos-api.apistemic.com/domain:meta.com', bg: '#0081FB', text: '#FFFFFF' },
  NFLX: { logo: 'https://logos-api.apistemic.com/domain:netflix.com', bg: '#E50914', text: '#FFFFFF' },
  NVDA: { logo: 'https://logos-api.apistemic.com/domain:nvidia.com', bg: '#76B900', text: '#FFFFFF' },
  BA: { logo: 'https://logos-api.apistemic.com/domain:boeing.com', bg: '#0033A0', text: '#FFFFFF' },
  JPM: { logo: 'https://logos-api.apistemic.com/domain:jpmorganchase.com', bg: '#003087', text: '#FFFFFF' },
  GS: { logo: 'https://logos-api.apistemic.com/domain:goldmansachs.com', bg: '#6CACE4', text: '#000000' },
  BAC: { logo: 'https://logos-api.apistemic.com/domain:bankofamerica.com', bg: '#012169', text: '#FFFFFF' },
  WMT: { logo: 'https://logos-api.apistemic.com/domain:walmart.com', bg: '#0071CE', text: '#FFFFFF' },
  DIS: { logo: 'https://logos-api.apistemic.com/domain:disney.com', bg: '#006E99', text: '#FFFFFF' },
  CVX: { logo: 'https://logos-api.apistemic.com/domain:chevron.com', bg: '#0066B3', text: '#FFFFFF' },
  AMD: { logo: 'https://logos-api.apistemic.com/domain:amd.com', bg: '#ED1C24', text: '#FFFFFF' },
  INTC: { logo: 'https://logos-api.apistemic.com/domain:intel.com', bg: '#0071C5', text: '#FFFFFF' },
  ORCL: { logo: 'https://logos-api.apistemic.com/domain:oracle.com', bg: '#F80000', text: '#FFFFFF' },
  IBM: { logo: 'https://logos-api.apistemic.com/domain:ibm.com', bg: '#054ADA', text: '#FFFFFF' },
  ADBE: { logo: 'https://logos-api.apistemic.com/domain:adobe.com', bg: '#FF0000', text: '#FFFFFF' },
  PYPL: { logo: 'https://logos-api.apistemic.com/domain:paypal.com', bg: '#003087', text: '#FFFFFF' },
  UBER: { logo: 'https://logos-api.apistemic.com/domain:uber.com', bg: '#000000', text: '#FFFFFF' },
  LYFT: { logo: 'https://logos-api.apistemic.com/domain:lyft.com', bg: '#FF00BF', text: '#FFFFFF' },
  PFE: { logo: 'https://logos-api.apistemic.com/domain:pfizer.com', bg: '#0093D0', text: '#FFFFFF' },
  MRNA: { logo: 'https://logos-api.apistemic.com/domain:modernatx.com', bg: '#00A1DE', text: '#FFFFFF' },
  KO: { logo: 'https://logos-api.apistemic.com/domain:coca-cola.com', bg: '#F40009', text: '#FFFFFF' },
  PEP: { logo: 'https://logos-api.apistemic.com/domain:pepsico.com', bg: '#004B93', text: '#FFFFFF' },
  XOM: { logo: 'https://logos-api.apistemic.com/domain:exxonmobil.com', bg: '#F01523', text: '#FFFFFF' },
  T: { logo: 'https://logos-api.apistemic.com/domain:att.com', bg: '#00A8E0', text: '#FFFFFF' },
  V: { logo: 'https://logos-api.apistemic.com/domain:visa.com', bg: '#1A1F71', text: '#FFFFFF' },
  MA: { logo: 'https://logos-api.apistemic.com/domain:mastercard.com', bg: '#EB001B', text: '#FFFFFF' },
  CSCO: { logo: 'https://logos-api.apistemic.com/domain:cisco.com', bg: '#049FD9', text: '#FFFFFF' },
  CRM: { logo: 'https://logos-api.apistemic.com/domain:salesforce.com', bg: '#00A1E0', text: '#FFFFFF' },
  COST: { logo: 'https://logos-api.apistemic.com/domain:costco.com', bg: '#005DAA', text: '#FFFFFF' },
  AVGO: { logo: 'https://logos-api.apistemic.com/domain:broadcom.com', bg: '#CC092F', text: '#FFFFFF' },
  TXN: { logo: 'https://logos-api.apistemic.com/domain:ti.com', bg: '#CC0000', text: '#FFFFFF' },
  QCOM: { logo: 'https://logos-api.apistemic.com/domain:qualcomm.com', bg: '#3253DC', text: '#FFFFFF' },
  AMAT: { logo: 'https://logos-api.apistemic.com/domain:appliedmaterials.com', bg: '#005FAD', text: '#FFFFFF' },
  INTU: { logo: 'https://logos-api.apistemic.com/domain:intuit.com', bg: '#365EBF', text: '#FFFFFF' },
  SBUX: { logo: 'https://logos-api.apistemic.com/domain:starbucks.com', bg: '#00704A', text: '#FFFFFF' },
  MCD: { logo: 'https://logos-api.apistemic.com/domain:mcdonalds.com', bg: '#FFC72C', text: '#000000' },
  LOW: { logo: 'https://logos-api.apistemic.com/domain:lowes.com', bg: '#004990', text: '#FFFFFF' },
  HD: { logo: 'https://logos-api.apistemic.com/domain:homedepot.com', bg: '#F96302', text: '#FFFFFF' },
  CAT: { logo: 'https://logos-api.apistemic.com/domain:cat.com', bg: '#FFCD11', text: '#000000' },
  HON: { logo: 'https://logos-api.apistemic.com/domain:honeywell.com', bg: '#D40511', text: '#FFFFFF' },
  AMGN: { logo: 'https://logos-api.apistemic.com/domain:amgen.com', bg: '#0063BE', text: '#FFFFFF' },
  LLY: { logo: 'https://logos-api.apistemic.com/domain:lilly.com', bg: '#D52B1E', text: '#FFFFFF' },
  UNH: { logo: 'https://logos-api.apistemic.com/domain:unitedhealthgroup.com', bg: '#002677', text: '#FFFFFF' },
  ABT: { logo: 'https://logos-api.apistemic.com/domain:abbott.com', bg: '#009CDE', text: '#FFFFFF' },
  CVS: { logo: 'https://logos-api.apistemic.com/domain:cvshealth.com', bg: '#CC0000', text: '#FFFFFF' },
  WFC: { logo: 'https://logos-api.apistemic.com/domain:wellsfargo.com', bg: '#D71E28', text: '#FFFFFF' },
  MS: { logo: 'https://logos-api.apistemic.com/domain:morganstanley.com', bg: '#13294B', text: '#FFFFFF' },
  AXP: { logo: 'https://logos-api.apistemic.com/domain:americanexpress.com', bg: '#006FCF', text: '#FFFFFF' },
  BLK: { logo: 'https://logos-api.apistemic.com/domain:blackrock.com', bg: '#000000', text: '#FFFFFF' },
  C: { logo: 'https://logos-api.apistemic.com/domain:citigroup.com', bg: '#003B70', text: '#FFFFFF' },
  BK: { logo: 'https://logos-api.apistemic.com/domain:bnymellon.com', bg: '#002855', text: '#FFFFFF' },
  TGT: { logo: 'https://logos-api.apistemic.com/domain:target.com', bg: '#CC0000', text: '#FFFFFF' },
  NKE: { logo: 'https://logos-api.apistemic.com/domain:nike.com', bg: '#F36F21', text: '#FFFFFF' },
  SHOP: { logo: 'https://logos-api.apistemic.com/domain:shopify.com', bg: '#96BF48', text: '#FFFFFF' },
  SNOW: { logo: 'https://logos-api.apistemic.com/domain:snowflake.com', bg: '#29B5E8', text: '#FFFFFF' },
  PLTR: { logo: 'https://logos-api.apistemic.com/domain:palantir.com', bg: '#101113', text: '#FFFFFF' },
};

export const INDEX_LOGOS: Record<string, { logo?: string; color: string; label: string }> = {
  SPY: { logo: 'https://logos-api.apistemic.com/domain:ssga.com', color: '#1a5f2a', label: 'SPY' },
  QQQ: { logo: 'https://logos-api.apistemic.com/domain:invesco.com', color: '#003087', label: 'QQQ' },
  DIA: { logo: 'https://logos-api.apistemic.com/domain:ssga.com', color: '#003087', label: 'DIA' },
  IWM: { logo: 'https://logos-api.apistemic.com/domain:ishares.com', color: '#000000', label: 'IWM' },
  VTI: { logo: 'https://logos-api.apistemic.com/domain:vanguard.com', color: '#96172E', label: 'VTI' },
  VOO: { logo: 'https://logos-api.apistemic.com/domain:vanguard.com', color: '#96172E', label: 'VOO' },
  ARKK: { logo: 'https://logos-api.apistemic.com/domain:ark-invest.com', color: '#000000', label: 'ARK' },
  CAC: { color: '#002395', label: 'CAC' },
  ASX: { color: '#FFCD00', label: 'ASX' },
  XLK: { logo: 'https://logos-api.apistemic.com/domain:ssga.com', color: '#00A36C', label: 'XLK' },
  XLF: { logo: 'https://logos-api.apistemic.com/domain:ssga.com', color: '#003087', label: 'XLF' },
  XLE: { logo: 'https://logos-api.apistemic.com/domain:ssga.com', color: '#000000', label: 'XLE' },
  XLY: { logo: 'https://logos-api.apistemic.com/domain:ssga.com', color: '#FF6B00', label: 'XLY' },
  XLP: { logo: 'https://logos-api.apistemic.com/domain:ssga.com', color: '#1a5f2a', label: 'XLP' },
  XLV: { logo: 'https://logos-api.apistemic.com/domain:ssga.com', color: '#0066CC', label: 'XLV' },
  XLI: { logo: 'https://logos-api.apistemic.com/domain:ssga.com', color: '#FFC300', label: 'XLI' },
  XLB: { logo: 'https://logos-api.apistemic.com/domain:ssga.com', color: '#8B4513', label: 'XLB' },
  XLU: { logo: 'https://logos-api.apistemic.com/domain:ssga.com', color: '#FFD700', label: 'XLU' },
  IYR: { logo: 'https://logos-api.apistemic.com/domain:ishares.com', color: '#000000', label: 'IYR' },
  SMH: { logo: 'https://logos-api.apistemic.com/domain:vaneck.com', color: '#00A36C', label: 'SMH' },
  SOXX: { logo: 'https://logos-api.apistemic.com/domain:ishares.com', color: '#003087', label: 'SOX' },
  TLT: { logo: 'https://logos-api.apistemic.com/domain:ishares.com', color: '#4169E1', label: 'TLT' },
  HYG: { logo: 'https://logos-api.apistemic.com/domain:ishares.com', color: '#8B0000', label: 'HYG' },
  GLD: { logo: 'https://logos-api.apistemic.com/domain:ssga.com', color: '#FFD700', label: 'GLD' },
  SLV: { logo: 'https://logos-api.apistemic.com/domain:ishares.com', color: '#C0C0C0', label: 'SLV' },
  BITO: { logo: 'https://logos-api.apistemic.com/domain:proshares.com', color: '#F7931A', label: 'BTC' },
  SPYD: { logo: 'https://logos-api.apistemic.com/domain:ssga.com', color: '#1a5f2a', label: 'SPY' },
  JEPI: { logo: 'https://logos-api.apistemic.com/domain:jpmorganchase.com', color: '#003087', label: 'JPM' },
};

export const COMMODITY_IMAGES: Record<string, { image?: string; gradient: string; symbol: string }> = {
  XAU: {
    image: 'https://images.pexels.com/photos/47047/gold-ingots-golden-treasure-47047.jpeg?auto=compress&cs=tinysrgb&w=100&h=100&fit=crop',
    gradient: 'from-yellow-400 to-amber-500',
    symbol: 'Au'
  },
  XAG: {
    image: 'https://images.pexels.com/photos/20979924/pexels-photo-20979924.jpeg?auto=compress&cs=tinysrgb&w=100&h=100&fit=crop',
    gradient: 'from-gray-300 to-gray-400',
    symbol: 'Ag'
  },
  XPT: {
    image: 'https://images.pexels.com/photos/20979923/pexels-photo-20979923.jpeg?auto=compress&cs=tinysrgb&w=100&h=100&fit=crop',
    gradient: 'from-slate-200 to-slate-400',
    symbol: 'Pt'
  },
  XPD: {
    image: 'https://images.pexels.com/photos/20979925/pexels-photo-20979925.jpeg?auto=compress&cs=tinysrgb&w=100&h=100&fit=crop',
    gradient: 'from-zinc-300 to-zinc-500',
    symbol: 'Pd'
  },
  WTICO: {
    image: 'https://images.pexels.com/photos/162568/oil-pump-jack-sunset-clouds-silhouette-162568.jpeg?auto=compress&cs=tinysrgb&w=100&h=100&fit=crop',
    gradient: 'from-slate-700 to-slate-900',
    symbol: 'WTI'
  },
  BCO: {
    image: 'https://images.pexels.com/photos/257700/pexels-photo-257700.jpeg?auto=compress&cs=tinysrgb&w=100&h=100&fit=crop',
    gradient: 'from-amber-700 to-amber-900',
    symbol: 'BCO'
  },
  NATGAS: {
    image: 'https://images.pexels.com/photos/6126281/pexels-photo-6126281.jpeg?auto=compress&cs=tinysrgb&w=100&h=100&fit=crop',
    gradient: 'from-blue-400 to-blue-600',
    symbol: 'NG'
  },
  CORN: {
    image: 'https://images.pexels.com/photos/547263/pexels-photo-547263.jpeg?auto=compress&cs=tinysrgb&w=100&h=100&fit=crop',
    gradient: 'from-yellow-300 to-yellow-500',
    symbol: 'C'
  },
  WHEAT: {
    image: 'https://images.pexels.com/photos/326082/pexels-photo-326082.jpeg?auto=compress&cs=tinysrgb&w=100&h=100&fit=crop',
    gradient: 'from-amber-300 to-amber-500',
    symbol: 'W'
  },
  SUGAR: {
    image: 'https://images.pexels.com/photos/5988340/pexels-photo-5988340.jpeg?auto=compress&cs=tinysrgb&w=100&h=100&fit=crop',
    gradient: 'from-white to-gray-100',
    symbol: 'SB'
  },
};

export function getAssetSymbol(symbol: string): string {
  if (symbol.endsWith('USDT')) {
    return symbol.replace('USDT', '');
  }
  if (symbol.includes('/')) {
    return symbol.split('/')[0];
  }
  return symbol;
}

export function getForexPairCurrencies(symbol: string): [string, string] | null {
  if (symbol.includes('/')) {
    const [base, quote] = symbol.split('/');
    return [base, quote];
  }
  return null;
}
